export default __webpack_public_path__ + "static/media/client-ic-comment.0143344a.svg";